export const parseApiErrorMessage = (error: unknown, fallback: string): string => {
    if (!(error instanceof Error)) {
        return fallback;
    }

    const marker = ' - ';
    const markerIndex = error.message.indexOf(marker);
    if (markerIndex === -1) {
        return error.message || fallback;
    }

    const payload = error.message.slice(markerIndex + marker.length);
    try {
        const parsed = JSON.parse(payload) as Record<string, unknown>;
        const messages = Object.values(parsed).flatMap((value) => {
            if (Array.isArray(value)) {
                return value.map((item) => String(item));
            }
            if (typeof value === 'string') {
                return [value];
            }
            return [];
        });

        if (messages.length > 0) {
            return messages.join(' | ');
        }
    } catch {
        return payload;
    }

    return error.message || fallback;
};

export const formatDateTime = (iso: string | null): string => {
    if (!iso) {
        return 'Unbekannt';
    }
    const parsed = new Date(iso);
    if (Number.isNaN(parsed.getTime())) {
        return iso;
    }
    return parsed.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};
